module.exports = __webpack_public_path__ + "img/cross.7e83367c.svg";